import ru from "./locales/ru.ts";
import en from "./locales/en.ts";

export type Language = "ru" | "en";
type TranslationDict = typeof ru; // можно и en, т.к. структура одинаковая

type TranslationServiceConfig = {
  langArr: Language[]; 
  initialLanguage?: Language; 
  fallbackLanguage: Language; 
}

class TranslationService {
  dictionary: Record<Language, TranslationDict> = {
    ru: ru,
    en: en,
  };

  langArr: Language[];
  fallbackLanguage: Language;
  currentLanguage: Language | null = null;

  constructor({ langArr, initialLanguage, fallbackLanguage }: TranslationServiceConfig) {
    this.langArr = langArr;
    this.fallbackLanguage = fallbackLanguage;
    this.currentLanguage = initialLanguage ?? this.getLanguageFromBrowser();
  }

  /** getters */
  get availableLanguages() {
    return [...this.langArr];
  }

  get currentLang() {
    if (this.currentLanguage) {
      return this.currentLanguage;
    }
    return this.getLanguageFromBrowser();
  }

  get translation(): TranslationDict {
    return this.getTranslation();
  }

  createReactiveTranslations(): TranslationDict {
    const handler = {
      get: (target: TranslationDict, prop: string | symbol) => {
        const currentTranslation = this.getTranslation();
        return currentTranslation[prop as keyof TranslationDict];
      },
    };

    return new Proxy({} as TranslationDict, handler);
  }

  /** methods */
  getLanguageFromBrowser(): Language {
    const browserLanguage = navigator.language;
    const formatedLang = browserLanguage.split("-")[0].toLowerCase() as Language;

    const lang = this.langArr.includes(formatedLang) ? formatedLang : this.fallbackLanguage;
    this.currentLanguage = lang;
    return lang;
  }

  getTranslation(language?: Language): TranslationDict {
    const lang = language || this.currentLang;
    return this.dictionary[lang] || this.dictionary[this.fallbackLanguage];
  }

  setLanguageFromBrowser() {
    this.getLanguageFromBrowser();
  }

  setLanguage(language: Language) {
    if (this.langArr.includes(language)) {
      this.currentLanguage = language;
    } else {
      console.warn(`Language ${language} is not supported`);
    }
  }
}

export { TranslationService };
